export default __webpack_public_path__ + "static/media/icon-publishing.2e7fa0a9.svg";